import { render, staticRenderFns } from "./addImage.vue?vue&type=template&id=84f2d7e8&ref=addImage&"
import script from "./addImage.vue?vue&type=script&lang=js&"
export * from "./addImage.vue?vue&type=script&lang=js&"
import style0 from "./addImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports